// extracted by css-extract-rspack-plugin
export default {"base":"MaLmiTCQn4QMQHd6 XdEXUDQMeQW55Yp5","validInput":"clnbDLk7QTsGVXYZ","validIcon":"Q2F4Fm8ZU6PRhi9G","_default":"AcxGLpXu7b0c3eFD","minimal":"yFpJBOMXadwuDUws"};